export default "/images/how_do_audits_work__text.png";